// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnswerRequest
 */
export interface AnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof AnswerRequest
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof AnswerRequest
     */
    conversationId?: string | null;
}

/**
 * Check if a given object implements the AnswerRequest interface.
 */
export function instanceOfAnswerRequest(value: object): value is AnswerRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function AnswerRequestFromJSON(json: any): AnswerRequest {
    return AnswerRequestFromJSONTyped(json, false);
}

export function AnswerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
        'conversationId': json['conversation_id'] == null ? undefined : json['conversation_id'],
    };
}

export function AnswerRequestToJSON(json: any): AnswerRequest {
    return AnswerRequestToJSONTyped(json, false);
}

export function AnswerRequestToJSONTyped(value?: AnswerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'query': value['query'],
        'conversation_id': value['conversationId'],
    };
}

